import { render, staticRenderFns } from "./hashtag.vue?vue&type=template&id=652bd87d&"
import script from "./hashtag.vue?vue&type=script&lang=ts&"
export * from "./hashtag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports